import { Component } from "react";
import Header from "../Header/Header";
import ContentLeft from "./ContentLeft/ContentLeft";
import "./FirstSection.scss";
import ContentRight from "./ContentRight/ContentRight";

class FirstSection extends Component {
  render() {
    return (
      <div className="first-section">
        <Header />
        <div className="first-section-content">
          <ContentLeft
            title={"Nosso foco é proteger a sua marca!"}
            subtitle={
              <div>
                Descubra <span id="yellow">gratuitamente</span> se sua marca
                está disponível para registro!
              </div>
            }
          />
          <ContentRight />
        </div>
      </div>
    );
  }
}

export default FirstSection;
